import { render, staticRenderFns } from "./NotificationOptions.vue?vue&type=template&id=4b541e6d&scoped=true"
import script from "./NotificationOptions.vue?vue&type=script&lang=js"
export * from "./NotificationOptions.vue?vue&type=script&lang=js"
import style0 from "./NotificationOptions.vue?vue&type=style&index=0&id=4b541e6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b541e6d",
  null
  
)

export default component.exports